module.exports = __webpack_public_path__ + "static/media/AvenirNext700.d17de959.woff";